import { faUserPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex, Text, useOpenModal } from '@modusign/design-system';

import GrantResourceSharingTargetModal from '@app/components/GrantResourceSharingTargetModal';
import { ThinButton } from '@app/components/ThinButton';
import { ResourceRoleSubject, ResourceRoleSubjectChip } from '@app/features/authorization';
import useGetUserAutoSharingTargets from '@app/features/workspaceManagement/hooks/useGetUserAutoSharingTargets';
import { useCurrentUserMemberId } from '@app/hooks/workspace';

interface DocumentSharingContentProps {
  documentName: string;
  roleSubjects?: ResourceRoleSubject[];
  setRoleSubjects: (r: ResourceRoleSubject[]) => void;
}

export default function DocumentSharingContent({
  documentName,
  roleSubjects,
  setRoleSubjects,
}: DocumentSharingContentProps) {
  const openModal = useOpenModal();
  const memberId = useCurrentUserMemberId();
  const currentUserAutomaticSharingTargets = useGetUserAutoSharingTargets({
    memberId,
  });
  return (
    <Flex flexDirection="column" mt={6}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Flex alignItems="center" height="18px" justifyContent="center" mr="3px" width="18px">
            <FontAwesomeIcon color="#848484" icon={faUserPlus} />
          </Flex>
          <Text as="p" color="textNeutralLight">
            문서 추가 공유 (선택)
          </Text>
        </Flex>
        <ThinButton
          onClick={() => {
            openModal((modalProps) => (
              <GrantResourceSharingTargetModal
                initialState={roleSubjects}
                isOpen={modalProps.isOpen}
                mode="additional"
                nonAssignables={currentUserAutomaticSharingTargets.data}
                subtitle={documentName}
                title="문서 추가 공유"
                onClose={modalProps.onClose}
                onConfirm={(targets) => {
                  setRoleSubjects(targets);
                  modalProps.onClose();
                }}
              />
            ));
          }}
        >
          공유 설정
        </ThinButton>
      </Flex>
      <Flex flexWrap="wrap" px={6} py={4} sx={{ gap: 3 }}>
        {roleSubjects?.map((t) => (
          <ResourceRoleSubjectChip key={t.subjectId}>
            {t.subjectType === 'MEMBER' ? t.memberName : t.groupName}
          </ResourceRoleSubjectChip>
        ))}
      </Flex>
    </Flex>
  );
}
